module.exports = __webpack_public_path__ + "img/hi_get.d16ad2c.png";